import { Link, useLocation } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { mergeQueryString } from 'bernie-core';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { LodgingPwaPropertySearch, SearchDialogMessage, SearchLinkMessage } from '__generated__/api/types';

import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkText } from 'uitk-react-text';

import { LegalDialog } from './legal-dialog';

const LinkTracked = ClickTracker(Link);
const ATracked = ClickTracker('a');

export type HeaderMessageLinkProps = {
  linkName?: string;
} & LodgingPwaPropertySearch.ResultsSummary &
  Omit<SearchLinkMessage.Fragment, '__typename'> &
  Omit<SearchDialogMessage.Fragment, '__typename'>;

export const HeaderMessageLink: React.FunctionComponent<HeaderMessageLinkProps> = ({
  icon,
  link,
  label,
  linkName,
  value,
  dialogTrigger,
}) => {
  const location = useLocation();

  const triggerContent = (
    <>
      <UitkText weight="bold">{value}</UitkText>
      <span hidden id="header-message-link-label">
        {label}
      </span>
      {icon && <UitkIcon name={icon.id} id={icon.id} />}
    </>
  );

  const trigger = dialogTrigger ? (
    <>
      <UitkMoreInfoTrigger type={200}>
        <LinkTracked
          to={`${location.pathname}?${mergeQueryString(location.search, { pwaDialog: dialogTrigger.dialogName })}`}
          linkName={value}
          rfrr={dialogTrigger.referrerId}
          aria-describedby="header-message-link-label"
        >
          {triggerContent}
        </LinkTracked>
      </UitkMoreInfoTrigger>

      <LegalDialog dialogName={dialogTrigger.dialogName} {...dialogTrigger.actionDetails} />
    </>
  ) : (
    <UitkMoreInfoTrigger type={200}>
      <ATracked
        href={link.url}
        linkName={linkName || value}
        rfrr={link.referrerId}
        target="_blank"
        rel="noopener"
        aria-describedby="header-message-link-label"
      >
        {triggerContent}
      </ATracked>
    </UitkMoreInfoTrigger>
  );

  return (
    <Viewport>
      <ViewSmall>
        <UitkLayoutPosition type="relative" position={{ bottom: 'one', left: 'center' }} cloneElement>
          {trigger}
        </UitkLayoutPosition>
      </ViewSmall>
      <ViewLarge>{trigger}</ViewLarge>
    </Viewport>
  );
};

HeaderMessageLink.displayName = 'HeaderMessageLink';
